export const normalizeUrl = (url: string): string => {
  if (/^https?:\/\//.test(url)) {
    return url
  }

  return `https://${url}`
}
